import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Person_PageMenu_ApiEnum } from './PersonDetailConfigApiInterface';

export enum Config_DelegateDetail_ActionsMenu_ApiEnum {
    'archive' = 'archive',
}

export enum Config_DelegateDetail_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'matches' = 'matches',
    'billing_fields_in_overview' = 'billing_fields_in_overview',
}

export enum Config_DelegateDetail_ActionsOther_ApiEnum {
    'upload_photo' = 'upload_photo',
}

export enum Config_DelegateDetail_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_DelegateDetail_ApiInterface
    extends ConfigDataInterface<
        Config_DelegateDetail_Modules_ApiEnum,
        Config_DelegateDetail_ActionsMenu_ApiEnum,
        Config_DelegateDetail_ActionsOther_ApiEnum,
        Config_Person_PageMenu_ApiEnum,
        Config_DelegateDetail_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
